var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { Redirect, Route } from 'react-router-dom';
//@ts-ignore
import { parse } from 'query-string';
export var SocialRedirect = function (_a) {
    var t = _a.t;
    return (React.createElement(Route, null, function (_a) {
        var search = _a.location.search;
        return parse(search).error ? (React.createElement(Redirect, { to: '/login' })) : (React.createElement("section", null, t(templateObject_1 || (templateObject_1 = __makeTemplateObject(["Success! Wait for redirect"], ["Success! Wait for redirect"])))));
    }));
};
var templateObject_1;
//# sourceMappingURL=SocialRedirect.js.map